import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import Layout from "@/layout/Layout.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    component: Layout,
    children: [
      {
        path: "",
        name: "home",
        component: () => import("@/views/Home/index.vue"),
      },
      {
        path: "/course",
        name: "course",
        component: () => import("@/views/Course/index.vue"),
      },
      {
        path: "/partner-course",
        name: "partnerCourse",
        component: () => import("@/views/PartnerCourse/index.vue"),
      },
      {
        path: "/news",
        name: "news",
        component: () => import("@/views/News/index.vue"),
      },
      {
        path: "/customized",
        name: "customized",
        component: () => import("@/views/Customized/index.vue"),
      },
      {
        path: "/about",
        name: "about",
        component: () => import("@/views/About/index.vue"),
      },
      {
        path: "/video",
        name: "video",
        component: () => import("@/views/Course/Video.vue"),
      },
      {
        path: "/center",
        name: "center",
        component: () => import("@/views/Center/index.vue"),
        meta: {
          hidNavFoo: true,
        },
      },
      {
        path: "/course/:courseId",
        name: "courseInfo",
        component: () => import("@/views/Course/Info.vue"),
        props: true,
      },
      {
        path: "/partner-course/:partnerCourseId",
        name: "partnerCourseInfo",
        component: () => import("@/views/PartnerCourse/Info.vue"),
        props: true,
      },
      {
        path: "/newsInfo",
        name: "newsInfo",
        component: () => import("@/views/News/Info.vue"),
      },
      {
        path: "/news_share",
        name: "news_share",
        component: () => import("@/views/News/Share.vue"),
        meta: {
          hidNavFoo: true,
          fullScreen: true,
        },
      },
      {
        path: "/online",
        name: "online",
        component: () => import("@/views/Training/Online.vue"),
      },
      {
        path: "/offline",
        name: "offline",
        component: () => import("@/views/Training/Offline.vue"),
      },
      {
        path: "/trainInfo",
        name: "trainInfo",
        component: () => import("@/views/Training/Info.vue"),
      },
      {
        path: "/train_share",
        name: "train_share",
        component: () => import("@/views/Training/Share.vue"),
        meta: {
          hidNavFoo: true,
          fullScreen: true,
        },
      },
      {
        path: "/exam",
        name: "exam",
        component: () => import("@/views/Exam/index.vue"),
      },
      {
        path: "/cert",
        name: "cert",
        component: () => import("@/views/Cert/index.vue"),
        meta: {
          hidNavFoo: true,
          fullScreen: true,
        },
      },
      {
        path: "/certquery",
        name: "certquery",
        component: () => import("@/views/Cert/Query.vue"),
      },
    ],
  },
];

const router = createRouter({
  // 路由模式
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
